import React from 'react';
import styled from '@styled';
import { font_nunito, tabletPortrait } from '../global.styles';

interface StyledLiProps {
  fontSize?: string;
  color?: string;
  margin?: string;
  padding?: string;
  textAlign?: string;
  fontWeight?: string;
  maxWidth?: string;
  mobileFontSize?: string;
  textDecoration?: string;
  fontFamily?: string;
  markerColor?: string;
  boldColor?: string;
}

export const StyledLi = styled('li').withConfig({
  shouldForwardProp: (prop) =>
    ![
      'fontSize',
      'textAlign',
      'fontWeight',
      'maxWidth',
      'mobileFontSize',
      'textDecoration',
      'fontFamily',
      'markerColor',
      'boldColor',
    ].includes(prop),
})<StyledLiProps>`
  font-size: ${(props) => props.fontSize || '16px'};
  color: ${(props) => props.color || '#000'};
  margin: ${(props) => props['data-margin'] || '0'};
  padding: ${(props) => props.padding || '0'};
  text-align: ${(props) => props.textAlign || 'start'};
  font-weight: ${(props) => props.fontWeight || '500'};
  font-family: ${(props) => props.fontFamily || font_nunito};
  font-style: normal;
  a {
    color: ${(props) => props.linkColor || '#0c6693'} !important;
  }
  &::marker {
    color: ${(props) => props.markerColor || props.color || '#000'};
  }
  strong {
    color: ${(props) => props.boldColor || props.color || '#000'};
  }
  ${tabletPortrait} {
    font-size: ${(props) => props.mobileFontSize || props.fontSize || '16px'};
  }
`;
